import { useState } from 'react'
import { LogIn, LogOut, User } from 'lucide-react'
import { useAuthStore } from '@/shared/session'
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@/shared/ui'

import { LoginDialog } from '@/features/auth'

export default function AuthButton() {
  const user = useAuthStore((s) => s.user)
  const loading = useAuthStore((s) => s.loading)
  const signOut = useAuthStore((s) => s.signOut)
  const [loginOpen, setLoginOpen] = useState(false)

  if (loading) return null

  if (!user) {
    return (
      <>
        <Button variant="link" onClick={() => setLoginOpen(true)}>
          <LogIn className="size-4" />
          Sign in
        </Button>
        <LoginDialog open={loginOpen} onOpenChange={setLoginOpen} />
      </>
    )
  }

  return (
    <>
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button variant="link" size="icon" aria-label="Account">
            <User className="size-4" />
          </Button>
        }
      />
      <DropdownMenuContent align="end">
        <div className="max-w-48 truncate px-1.5 py-1 text-xs text-muted-foreground">
          {user.name || user.email}
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => void signOut()}>
          <LogOut className="size-4" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
    </>
  )
}
